import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../styles/theme';
import { Button } from './Button';

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const Icon = theme === 'dark' ? Sun : Moon;
  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggle}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      title={theme === 'dark' ? 'Light mode' : 'Dark mode'}
    >
      <Icon size={16} strokeWidth={1.5} />
    </Button>
  );
}
